module.exports = __webpack_public_path__ + "static/media/dunia.baa125a9.jpg";